export const dictionary = {
    user: {
        properties: {
            title: {
                pattern: 'Must start with an alphanumeric character and can further consist of the following characters: .,?+-/*!@#%^&()_ . The minimum length is 4 and the maximum length is 50.'
            },
            locale: {
                enum: 'The next values are allowed: {allowedValues}.',
            }
        },
        default: 'Not a valid user profile definition.',
    },
    title: {
        pattern: 'Must start with an alphanumeric character and can further consist of the following characters: .,?+-/*!@#%^&()_ . The minimum length is 4 and the maximum length is 50.'
    },
    locale: {
        enum: 'The next values are allowed: {allowedValues}.',
    },
    secret: {
        retype: 'Not the same as the given (new )secret.'
    },
    type: 'Must be {type}.',
    string: 'textual',
    number: 'a number',
    null: 'empty',
    boolean: 'boolean',
};
